/**
 * A login route inside the secure group, which nobody who reaches this group has one for.
 *
 * It exists because `router.push('/login')` resolves relative to the group it is called
 * from, so a bare login href used from a secure route asks for this name rather than the
 * open group's screen. The tab layout declares it behind a guard that is closed for anyone
 * signed in — which, inside a group the secure layout only renders for a signed-in reader,
 * means closed always. The body below is therefore unreachable, and is `null` rather than
 * anything a reader could see behind a guard that has somehow failed open.
 *
 * The file stays because a guard can only drop a name the router knows about, and routes
 * come from the filesystem: delete this and there is nothing left to guard, only a bare
 * `/login` that resolves somewhere unintended.
 *
 * Known regression against the redirect this replaced, and one to fix at the call sites
 * rather than here: a dropped name is not a redirect. A full load of `/login` still resolves
 * away to the first surviving declaration, but an in-app `push` names a route the navigator
 * does not have, which is unhandled — the reader stays where they were, where the old
 * `Redirect` moved them on. Anything in the secure group that needs sign-in should name
 * `/(open)/login` explicitly rather than rely on this name catching it.
 */
export default function SecureLoginRoute() {
  return null;
}
